import { render, staticRenderFns } from "./paperDialog.vue?vue&type=template&id=161a7654&scoped=true"
import script from "./paperDialog.vue?vue&type=script&lang=js"
export * from "./paperDialog.vue?vue&type=script&lang=js"
import style0 from "./paperDialog.vue?vue&type=style&index=0&id=161a7654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_n3acbem2au4l2e3t4qvos3rwwq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161a7654",
  null
  
)

export default component.exports